
import FieldOptionModel from "./FieldOptionModel.js";
import FieldValidationModel from "./FieldValidationModel.js";
import BaseModel from "./_mbase.js";

const getString = value => (value == null || value == undefined) ? '' : value;


/**
 * @namespace
 * @property {string} title
 * @property {[FieldOptionModel]} fieldOptions
 */
class FieldModel extends BaseModel {


    _title = '';
    displayLabel = '';
    placeholder = '';
    attributes = {};
    type = 'single_text';
    defaultValue = '';
    code = '';
    /**@type {FieldOptionModel[] } */
    fieldOptions = [];
    validations = [];
    hint = '';
    formUUID = '';
    showLabel = true;
    showDesc = true;
    htmlTemplate = '';
    image = '';

    /**@type {{count_rule?:string min_length?:string, max_length?:string,}} */
    extends;
    maxLength = 300;
    minLength = 0;
    /** @type {any} - using as backup or store temp something */
    storeTemp;

    /** type {*} */
    userResponse = '';

    /**
     *
     * @returns  {string}
     * @readonly
     * @memberof FieldModel
     */
    get title() {
        return (typeof this.displayLabel === 'string' && this.displayLabel.length > 0) ? this.displayLabel : this._title;
    }

    set title(val) {
        return this._title = val;
    }

    // set userResponse(value) {
    //     debugger
    //     this._userResponse = value;
    //     this._useResponseCallbacks.forEach(cb =>{
    //         cb.call(this, value);
    //     })
    // }

    // get userResponse() {
    //     return this._userResponse;
    // }

    _useResponseCallbacks = []
    onUserResponse(cb) {
        if (typeof cb !== 'function') return;
        this._useResponseCallbacks.push(cb);
    }


    fromJSON(data, formUUID = '') {
        super.fromJSON(data);
        this._title = data['name'];
        this.displayLabel = data['displayLabel'];
        this.type = data['field_type'];
        this.placeholder = getString(data['placeholder']) || '';
        this.code = data['code'];
        this.hint = data['description'] || '';
        this.fieldOptions = (data['field_options'] || []).map(item => new FieldOptionModel().fromJSON(item).setName(this.code));
        this.validations = (data['validations'] || []).map(item => new FieldValidationModel().fromJSON(item));
        this.formUUID = formUUID;
        this.extends = data['extends']
        this.showLabel = true //  Boolean(data['show_field_name']);
        this.showDesc = Boolean(data['show_description']);
        this.displayLabel = data['label'];
        this.image = data['image']

        // this.htmlTemplate = data['description'];

        if (this.extends && this.extends.min_length) {
            this.minLength = this.extends['min_length'];
        }
        if (this.extends && this.extends.max_length) {
            this.maxLength = this.extends['max_length']
        }
        return this;
    }

    /**
     * 
     * @returns {string}
     */
    findDefaultOptionValue() {
        const defaultOption = this.fieldOptions.find(item => item.isDefault);
        return defaultOption ? defaultOption.value : '';
    }

    toUserResponse() {
        let userResponse =  this.userResponse;
        if(typeof userResponse === 'object'){
            userResponse = JSON.parse(JSON.stringify(userResponse));
        }
        return {
            "code": this.code,
            "value": userResponse
        }
    }

    /**
     * Using to check the value can use,
     * It always using for field that contain the option (Checkbox, dropdown, select...)
     * @returns {boolean}
     */
    canSetValue(value) {
        return this.fieldOptions.length > 0 ? !!this.fieldOptions.find(item => item.compareValue(value)) : true;
    }

    /**
     * @returns {FieldModel}
     */
    setFormUUID(uuid = '') {
        this.formUUID = uuid;
        return this;
    }
}


export default FieldModel;